/** @jsx h */
import { labels } from '../config';
import { useState } from 'preact/hooks';
import { getFormattedDate, getFormattedDateRange } from '../helpers/helpers';

const DatePickerFilter = ({ handleChange }) => {
  const [activeDateFilter, setActiveDateFilter] = useState(null);

  function handleClick(type) {
    setActiveDateFilter(type);

    const todayDate = new Date();

    if (type === 'today') {
      const dateValue = getFormattedDate(
        new Date(),
        'dateRange:___FROM___-___TO___'
      );
      handleChange(dateValue);
    }

    if (type === 'month') {
      const lastDayOfMonth = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth() + 1,
        0
      );
      const dateValue = getFormattedDateRange(
        new Date(),
        lastDayOfMonth,
        'dateRange:___FROM___-___TO___'
      );
      handleChange(dateValue);
    }

    if (type === 'next-month') {
      const firstDayOfNextMonth = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth() + 1,
        1
      );
      const lastDayOfNextMonth = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth() + 2,
        0
      );
      const dateValue = getFormattedDateRange(
        firstDayOfNextMonth,
        lastDayOfNextMonth,
        'dateRange:___FROM___-___TO___'
      );
      handleChange(dateValue);
    }

    if (type === 'week') {
      const weekStartsOn = 1; // 0 = sunday, 1 = monday
      const weekDays = 6; // index based
      const todayDay = todayDate.getDay();
      const endOfWeek =
        (todayDay < weekStartsOn ? -7 : 0) +
        weekDays -
        (todayDay - weekStartsOn);
      const endDayOfWeek = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate() + endOfWeek
      );
      const dateValue = getFormattedDateRange(
        new Date(),
        endDayOfWeek,
        'dateRange:___FROM___-___TO___'
      );
      handleChange(dateValue);
    }
  }

  return (
    <div class="filter__tag">
      <div class="form__field">
        <div class="form__group--tag">
          <div class="checkbox-group ">
            <button
              class={`checkbox ${
                activeDateFilter === 'today' ? 'is-active' : ''
              }`}
              onClick={() => handleClick('today')}
              type="button"
              aria-pressed={`${activeDateFilter === 'today'}`}
            >
              <span class="checkbox__label">{labels.datePicker.today}</span>
            </button>
          </div>

          <div class="checkbox-group ">
            <button
              class={`checkbox ${
                activeDateFilter === 'week' ? 'is-active' : ''
              }`}
              onClick={() => handleClick('week')}
              type="button"
              aria-pressed={`${activeDateFilter === 'week'}`}
            >
              <span class="checkbox__label">{labels.datePicker.week}</span>
            </button>
          </div>

          <div class="checkbox-group ">
            <button
              class={`checkbox ${
                activeDateFilter === 'month' ? 'is-active' : ''
              }`}
              onClick={() => handleClick('month')}
              type="button"
              aria-pressed={`${activeDateFilter === 'month'}`}
            >
              <span class="checkbox__label">{labels.datePicker.month}</span>
            </button>
          </div>

          <div class="checkbox-group ">
            <button
              class={`checkbox ${
                activeDateFilter === 'next-month' ? 'is-active' : ''
              }`}
              onClick={() => handleClick('next-month')}
              type="button"
              aria-pressed={`${activeDateFilter === 'next-month'}`}
            >
              <span class="checkbox__label">{labels.datePicker.nextMonth}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatePickerFilter;
